export const mainDisclaimerHeaderContent = {
  header: "TinyViva Website Disclaimer",
  lastUpdated: "Last updated: November 5, 2025",
  disclaimerIntro:
    "Welcome to TinyViva. Please read this disclaimer carefully before using our website. By accessing or using this site, you agree to all terms outlined below.",
};

export const mainDisclaimerDataContent = [
  {
    type: "para",
    dataHeader: "1. General Information Only",
    content: [
      "The content on this website is for informational and educational purposes only. It is not a substitute for professional medical, dietary, or healthcare advice. Always seek guidance from a qualified physician, registered dietitian, or other licensed professional regarding your health, nutrition, or medical condition.",
    ],
  },
  {
    type: "para",
    dataHeader: "2. No Medical or Health Advice",
    content: [
      "This website does not provide medical advice, diagnosis, or treatment. Reliance on any information provided here is at your own risk. Never disregard professional medical advice or delay seeking it because of something you have read on this site.",
    ],
  },
  {
    type: "para",
    dataHeader: "3. No Professional Relationship Established",
    content: [
      "Use of this Site does not create any doctor-patient, therapist-client, attorney-client, dietitian-client, or other professional-client relationship. Viewing, receiving, or transmitting information through the Site does not establish such a relationship.",
    ],
  },
  {
    type: "para",
    dataHeader: "4. Individual Results May Vary",
    content: [
      "Healthy eating and lifestyle changes affect individuals differently. Results will vary depending on factors such as age, health, genetics, and environment. TinyViva makes no guarantee of specific outcomes.",
    ],
  },
  {
    type: "para",
    dataHeader: "5. Food, Ingredients, and Allergen Disclaimer",
    content: [
      "Recipes or food suggestions provided may contain ingredients that could trigger allergies or intolerances. It is your responsibility to check ingredients and consult a healthcare professional before making dietary changes. Some ingredients or food products linked through external pages—such as those from Indian chefs or international creators—may not be approved by the U.S. Food and Drug Administration (FDA). Please exercise discretion and consult reliable health sources before use.",
    ],
  },
  {
    type: "para",
    dataHeader: "6. Child Safety and Supervision",
    content: [
      "Activities, games, or recipes intended for children must be used only under direct supervision of a parent or guardian. Parents or guardians are solely responsible for ensuring children's safety. This Site is not directed at children under 13, and TinyViva does not knowingly collect personal information from minors.",
    ],
  },
  {
    type: "para",
    dataHeader: "7. Children Featured in Media",
    content: [
      "Videos, photos, or media featuring children—including the TinyViva founders' twins—are published only with verified parental or guardian consent. These materials are the exclusive property of TinyViva or the original content owner. Unauthorized copying, downloading, distribution, or modification is strictly prohibited and may result in legal action. By using this Site, you agree not to capture, share, or exploit such content for any purpose. TinyViva reserves all legal rights and remedies in the event of misuse.",
    ],
  },
  {
    type: "para",
    dataHeader: "8. Guest Contributions and Interviews",
    content: [
      "Guest contributors—including healthcare professionals, chefs, and educators—express their own views. TinyViva does not endorse or guarantee the accuracy, completeness, or safety of third-party opinions or advice.",
    ],
  },
  {
    type: "para",
    dataHeader: "9. Third-Party Content and Links",
    content: [
      "This Site may contain links or embedded content from third-party websites or social-media platforms (including Instagram, YouTube, .org, or .edu, .com and .gov domains). Such material remains the responsibility of the original publisher or creator. TinyViva does not control, endorse, or guarantee the accuracy, reliability, or currency of any third-party content. Accessing these links is at your own risk.",
    ],
  },
  {
    type: "para",
    dataHeader: "10. Intellectual Property and Images",
    content: [
      "All original text, graphics, and videos on this Site are the property of TinyViva or licensed contributors. Third-party images used are royalty-free and copyright-free, as confirmed by Crayon Infotech (India), our website developer. Unauthorized reproduction, redistribution, or commercial use of any material is prohibited.",
    ],
  },
  {
    type: "para",
    dataHeader: "11. Technology, Downloads, and Limitation of Liability",
    content: [
      "The Site is provided “as is” and “as available,” without warranty of uninterrupted operation or freedom from harmful components. Users assume all risks associated with downloads, links, games, or technical issues. To the fullest extent permitted by law, TinyViva, its affiliates, contributors, partners, and agents are not liable for any direct, indirect, incidental, consequential, or punitive damages, including those related to health effects, allergies, injuries, emotional impact, technical disruptions, or data loss.",
    ],
  },
  {
    type: "para",
    dataHeader: "12. Governing Law and International Use",
    content: [
      "This Disclaimer is governed by the laws of the Home State or Country in which the TinyViva website owner resides at the time of any dispute, without regard to conflict-of-law principles. Any dispute must be brought individually in the courts located in that jurisdiction. If you access the Site from outside that country, you do so at your own risk and are responsible for compliance with local laws. TinyViva makes no representation that the Site's content is lawful or appropriate in other jurisdictions.",
    ],
  },
  {
    type: "para",
    dataHeader: "13. Class-Action Waiver",
    content: [
      "By using this Site, you waive any right to participate in class actions, collective actions, or representative proceedings.",
    ],
  },
  {
    type: "para",
    dataHeader: "14. Indemnification and Force Majeure",
    content: [
      "You agree to defend, indemnify, and hold harmless TinyViva, its affiliates, contributors, and agents from and against any claims, damages, or expenses (including attorney's fees) arising from your use of the Site, violation of these terms, or infringement of any third-party rights. TinyViva is not liable for delays or failures caused by events beyond its reasonable control, including natural disasters, pandemics, or technical failures.",
    ],
  },
  {
    type: "para",
    dataHeader: "15. Modifications and Entire Agreement",
    content: [
      "TinyViva may modify this Disclaimer at any time without notice. Continued use of the Site after revisions constitutes acceptance of the updated terms. This Disclaimer represents the entire agreement regarding use of the Site and supersedes all prior understandings.",
    ],
  },
  {
    type: "para",
    dataHeader: "16. Contact Us",
    content: [
      "If you have questions about this Disclaimer, please contact us at: Email: shivani.kapoor@tinyviva.com",
    ],
  },
];
